import { render, staticRenderFns } from "./T12.vue?vue&type=template&id=a4fd285e&"
import script from "./T12.vue?vue&type=script&lang=js&"
export * from "./T12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports